import { component } from 'picoapp'
import { getSizedImageUrl, imageSize } from '@/lib/images.js'
import { formatMoney } from '@/lib/currency.js'
import { fetchCart } from '@/lib/cart.js'
import { isEmpty, setNewCookie, deleteCookie } from '@/lib/ults.js'
import app from '@/app.js'
import $ from 'jquery'

function createItem({
    variant_id: id,
    product_title: title,
    line_price: price,
    variant_title: size,
    image,
    url,
    quantity,
    ...item // eslint-disable-line
}) {
    const img = image
        ? getSizedImageUrl(
              image.replace('.' + imageSize(image), ''),
              '300x300' // TODO hacky af
          )
        : 'https://source.unsplash.com/R9OS29xJb-8/2000x1333'

    /**
     * Check for wrapping items
     */
    const itemsWithWrapping = theme.cartItems, // items in the cart with the wrapping tag
        productId = item.product_id // Get the value of line_item properties, if they are not empty

    let hasWrapping = false,
        wrappingHandleForWrapping = undefined

    /**
     * Check if the product has wrapping tag to show checkbox for adding gift wrapping
     */
    if (itemsWithWrapping.length > 0) {
        itemsWithWrapping.forEach((item) => {
            if (item.id == productId) {
                hasWrapping = true
                wrappingHandleForWrapping = item.wrappingHandle.split('_')[1]
            }
        })
    }

    let prelovedTag = ''
    if (item.properties && item.properties.preloved) {
        prelovedTag = `<div><b>${window.theme.strings.preloved}</b></div>`
    }

    return `
        <li class="cart-drawer__item" data-id="${id}" data-component="cartDrawerItem">
            <div class="cart-drawer__item__img ${!hasWrapping ? 'is-wrapping' : ''}">
                <img src="${img}" alt="${title}">
            </div>

            <div class="cart-drawer__item__inner flex space-between">
                <div class="cart-drawer__item__left">
                    <p class="cart-drawer__item__title">
                        ${prelovedTag}
                        ${title}
                    </p>

                    ${
                        size == null || !hasWrapping
                            ? ''
                            : '<p class="cart-drawer__item__variant">' + theme.strings.sizeLabel + ': ' + size + '</p>'
                    }

                    <div class="cart-drawer__item__quantity ${
                        !hasWrapping ? 'visually-hidden' : ''
                    }"><div class="quantity js-remove-single">-</div><div class="quantity js-single-quantity">${quantity}</div><div class="quantity js-add-single">+</div></div>

                    ${
                        hasWrapping
                            ? '<label for="product-wrapping" class="cart-page__wrapping flex align-center" data-label data-title="' +
                              title +
                              '" data-handle="' +
                              wrappingHandleForWrapping +
                              '" data-product-id="' +
                              id +
                              '"><span class="cart-page__wrapping--checkbox" data-checkbox></span>' +
                              theme.strings.addWrapping +
                              '</label><input type="checkbox" name="wrapping" id="product-wrapping" data-input data-id="' +
                              id +
                              '">'
                            : ''
                    }

                    <div class="cart-page__list__item__properties flex align-center"></div>
                </div>

                <div class="cart-drawer__item__right">
                    <p class="cart-drawer__item__price">${formatMoney(price)}</p>
                    <div class="cart-drawer__item__remove js-remove-item">${theme.strings.cartRemove}</div>
                </div>
            </div>

            <a href="${url}" class="cart-drawer__item__link"></a>
        </li>
    `
}

function renderItems(items) {
    return items.length > 0
        ? items.reduce((markup, item) => {
              markup += createItem(item)
              return markup
          }, '')
        : `<li class="cart-drawer__list__empty">${theme.strings.cartEmpty}</li>`
}

export default component((node, ctx) => {
    const toggles = node.querySelectorAll('[data-toggle]')
    const subtotal = node.querySelector('[data-subtotal]')
    const total = node.querySelector('[data-total]')
    const shippingStatus = node.querySelector('[data-shipping-status]')
    const { shippingLimit, shippingPrice } = theme.cart
    const itemsRoot = node.querySelector('[data-items]')
    const loading = itemsRoot.innerHTML
    const drawer = node.querySelector('[data-drawer]')
    const cartCount = node.querySelector('[data-cart-count]')

    /**
     * Wrapping
     */
    const carDrawerFooter = document.querySelector('[data-cart-drawer-footer]')

    const fetchProducts = (wrappingHandle, productTitle) => {
        const wrappingProduct = window.theme.giftWrapItems.find((product) => product.handle == wrappingHandle)
        if (wrappingProduct) {
            const id = wrappingProduct.id

            $.ajax({
                url: '/cart/add.js',
                data: {
                    quantity: 1,
                    id,
                    properties: {
                        Produkt: productTitle,
                    },
                },
                dataType: 'JSON',
                success: function () {
                    setNewCookie(productTitle, id, 1)

                    app.emit('cart:updating')

                    return fetchCart().then((cart) => {
                        carDrawerFooter.classList.remove('hidden')

                        app.hydrate({ cart: cart })
                        app.emit('cart:updated', { cart: cart })
                    })
                },
                error: function () {
                    console.log('error')
                },
            })
        }
    }

    const handleWrapping = (cart) => {
        node.querySelectorAll('[data-input]')
        const labels = node.querySelectorAll('[data-label]'),
            checkboxes = node.querySelectorAll('[data-checkbox]')

        labels.forEach((label, i) => {
            label.addEventListener('click', () => {
                const wrappingHandle = label.dataset.handle,
                    productTitle = label.dataset.title

                if (checkboxes[i].classList.contains('checked')) {
                    const items = cart.items

                    items.forEach((item) => {
                        const prop = item.properties

                        // Check if there's a wrapping product in cart
                        if (!isEmpty(prop)) {
                            if (Object.values(prop) == productTitle) {
                                const correctWrappingItem = item,
                                    key = correctWrappingItem.key

                                $.post({
                                    url: '/cart/change.js',
                                    data: {
                                        quantity: 0,
                                        id: key,
                                    },
                                    dataType: 'JSON',
                                    success: function () {
                                        deleteCookie(productTitle)

                                        return fetchCart().then((cart) => {
                                            carDrawerFooter.classList.remove('hidden')

                                            app.hydrate({ cart: cart })
                                            app.emit('cart:updated', { cart: cart })
                                        })
                                    },
                                })
                            }
                        }
                    })
                } else {
                    checkboxes[i].classList.add('checked')
                    fetchProducts(wrappingHandle, productTitle)
                }
            })
        })
    }

    const checkIfHasWrapping = (cart) => {
        const items = cart.items,
            labels = node.querySelectorAll('[data-label]'),
            checkboxes = node.querySelectorAll('[data-checkbox]')

        let productName

        items.forEach((item) => {
            const props = item.properties == null ? {} : item.properties

            // Check if there's a wrapping product in cart
            if (!isEmpty(props)) {
                if (Object.keys('Produkt')) productName = Object.values(item.properties)
            }

            labels.forEach((label, i) => {
                const title = label.dataset.title

                if (title == productName) checkboxes[i].classList.add('checked')
            })
        })
    }

    const calculateFreeShipping = (cart) => {
        const minMax = (num, min, max) => Math.min(Math.max(num, min), max)

        const shippingPriceTag = document.querySelector('[data-shipping-price]')
        const giftCards = cart.items.filter((item) => item.gift_card)

        const extractGiftCardPrices = giftCards.map((item) => item.price)
        const giftCardsTotal = extractGiftCardPrices.reduce((sum, value) => sum + value, 0)

        const cartTotal = minMax(cart.total_price - giftCardsTotal, 0, cart.total_price)

        if (cart.total_price < shippingLimit && giftCards.length != cart.items.length)
            shippingPriceTag.innerText = window.theme.strings.shippingFrom.includes('translation missing')
                ? formatMoney(shippingPrice)
                : window.theme.strings.shippingFrom + ' ' + formatMoney(shippingPrice)
        else shippingPriceTag.innerText = formatMoney(0)

        // Render shipping progress
        const calculateProgress = () => {
            const progress = (cartTotal / shippingLimit) * 100
            return minMax(progress, 0, 100)
        }

        const renderProgress = () => {
            const progress = calculateProgress(cart)
            const progressBar = shippingStatus.querySelector('[data-shipping-progress]')

            progressBar.style.setProperty('--progress', `${progress}%`)
        }

        const renderStatus = () => {
            renderProgress()

            const buyMore = shippingStatus.querySelector('[data-more]')
            const current = shippingStatus.querySelector('[data-current]')
            const freeShipping = shippingStatus.querySelector('[data-free]')

            if (!buyMore || !current || !freeShipping) return

            if (cartTotal === 0) {
                buyMore.hidden = false
                current.hidden = true
                freeShipping.hidden = true

                const amount = buyMore.querySelector('[data-shipping-amount]')
                if (amount) {
                    amount.innerText = formatMoney(shippingLimit)
                }
            } else if (cartTotal >= shippingLimit) {
                buyMore.hidden = true
                current.hidden = true
                freeShipping.hidden = false
            } else {
                buyMore.hidden = true
                current.hidden = false
                freeShipping.hidden = true

                const amount = current.querySelector('[data-shipping-amount]')
                if (amount) {
                    amount.innerText = formatMoney(shippingLimit - cartTotal)
                }
            }
        }

        renderStatus()
    }

    const render = (cart) => {
        const giftCards = cart.items.filter((item) => item.gift_card)

        itemsRoot.innerHTML = renderItems(cart.items)
        subtotal.innerHTML = formatMoney(cart.total_price)
        cartCount.innerHTML = cart.item_count

        if (cart.total_price < shippingLimit && giftCards.length != cart.items.length)
            total.innerHTML = formatMoney(cart.total_price + shippingPrice)
        else total.innerHTML = formatMoney(cart.total_price)

        handleWrapping(cart)
        checkIfHasWrapping(cart)
        calculateFreeShipping(cart)
    }

    const open = (cart) => {
        node.classList.add('is-active')
        itemsRoot.innerHTML = loading
        setTimeout(() => {
            node.classList.add('is-visible')
            document.body.classList.add('is-visible')
            setTimeout(render(cart), 10)
            app.mount()
        }, 50)
    }

    const close = () => {
        node.classList.remove('is-visible')
        document.body.classList.remove('is-visible')
        setTimeout(() => {
            node.classList.remove('is-active')
            app.hydrate({ cartOpen: false })
        }, 400)
    }

    render(ctx.getState().cart)

    for (let i = 0; i < toggles.length; i++) toggles[i].addEventListener('click', close)

    ctx.on('cart:toggle', ({ cart, cartOpen }) => {
        if (cartOpen) open(cart)
    })
    ctx.on('cart:updated', () => {
        render(ctx.getState().cart)
        ctx.emit('cart:toggle', (state) => {
            return {
                cartOpen: !state.cartOpen,
            }
        })
        app.mount()
    })
})
